var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calibration",on:{"click":function($event){$event.preventDefault();return _vm.gotoHomepage.apply(null, arguments)}}},[_c('img',{attrs:{"src":require("@/assets/images/elements/playground-marker.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }